import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');

	const MAT = geo.createNode('materialsNetwork');
	const meshBasic = MAT.createNode('meshBasic');
	meshBasic.p.wireframe.set(1);

	// create an add node
	const sphere = geo.createNode('sphere');
	const plane = geo.createNode('plane');
	const merge = geo.createNode('merge');
	const uvUnwrap = geo.createNode('uvUnwrap');
	const point = geo.createNode('point');
	const material = geo.createNode('material');

	merge.setInput(0, sphere);
	merge.setInput(1, plane);
	merge.p.compact.set(1);
	uvUnwrap.setInput(0, merge);
	point.setInput(0, uvUnwrap);
	point.p.updateX.set(1);
	point.p.updateY.set(1);
	point.p.updateZ.set(1);
	point.p.x.set('@uv.x');
	point.p.y.set('@uv.y');
	point.p.z.set('0');
	material.setInput(0, point);
	material.p.material.setNode(meshBasic);
	material.flags.display.set(true);

	uvUnwrap.uiData.setComment(`When using the local app:
make sure to install the xatlast library,
with the top menu
Windows -> Libraries,
and click on 'Install XAtlast' button.
Then reload the page.`);

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [plane],
		autoLayout: true,
	};
}
// export const sopUvUnwrap = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/uvUnwrap`,
// 		createData,
// 		relatedNodes: [UvUnwrapSopNode],
// 	}),
// ];
